import { Toast } from 'vant';
import DetailDialog from '@/components/provincial_level/detail_dialog/detail_dialog';
import QrcodeDialog from '@/components/provincial_level/qrcode_dialog/qrcode_dialog';
import taxSvg from '@/assets/images/provincial/tax.svg';
import bornSvg from '@/assets/images/my_cs/born.svg';
import buildSvg from '@/assets/images/my_cs/build.svg';
import card2Svg from '@/assets/images/my_cs/card.svg';
import complainSvg from '@/assets/images/my_cs/complain.svg';
import etcSvg from '@/assets/images/my_cs/etc.svg';
import helpSvg from '@/assets/images/my_cs/help.svg';
import hospitalSvg from '@/assets/images/my_cs/hospital.svg';
import marrySvg from '@/assets/images/my_cs/marry.svg';
import oldSvg from '@/assets/images/my_cs/old.svg';
import socialSvg from '@/assets/images/my_cs/social.svg';
import workSvg from '@/assets/images/my_cs/work.svg';
import sick2Svg from '@/assets/images/my_cs/sick.svg';
import hospital2Svg from '@/assets/images/my_cs/hospital2.svg';

export default{
    name : 'edu_service',
    data () {
        return {
            // 是否显示弹出层
            isShowDialog: false,
            // 弹出层标题
            dialogTitle: '',
            // 弹出层数组
            dialogList: [],
            lock: false,
            list: [{
                menuName: '预约办事',
                menuType: 3,
                img: workSvg,
                url: 'pages/online-booking/index.html?title=预约办事',
                miniId: 'gh_7f57f7d2417e',
                data: '19;73;1'
            }, {
                menuName: '婚姻登记',
                menuType: 1,
                img: marrySvg,
                subMenu: [
                    {menuName: '婚姻登记预约',desc: '婚姻登记预约',url: 'pages/index/index', miniId: 'gh_e8b3f0c30337',data: '21;86;1'},
                    {menuName: '婚姻登记预约取消',desc: '婚姻登记预约取消',url: 'pages/index/index', miniId: 'gh_e8b3f0c30337',data: '21;86;1'},
                    {menuName: '离婚登记预约',desc: '婚姻登记预约',url: 'pages/index/index', miniId: 'gh_e8b3f0c30337',data: '21;86;1'},
                    {menuName: '离婚登记预约取消',desc: '婚姻登记预约取消',url: 'pages/index/index', miniId: 'gh_e8b3f0c30337',data: '21;86;1'},
                    {menuName: '离婚登记预约查询',desc: '婚姻登记预约取消',url: 'pages/index/index', miniId: 'gh_e8b3f0c30337',data: '21;86;1'},
                ]
            },{
                menuName: '社保',
                menuType: 3,
                img: socialSvg,
                url: 'sub-sb/pages/index.html?serviceId=renshe&title=社保',
                miniId: 'gh_7f57f7d2417e',
                data: '19;74;1'
            }, {
                menuName: '税务',
                menuType: 1,
                img: taxSvg,
                subMenu: [
                    {menuName: '企业信用',desc: '企业信用信息查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;49;1'},
                ]
            }, {
                menuName: '卡证',
                menuType: 3,
                img: card2Svg,
                url: 'sub-kz/pages/my-card-list/my-card-list.html?activeKey=card',
                miniId: 'gh_7f57f7d2417e',
                data: '19;75;1'
            },{
                menuName: 'ETC服务',
                menuType: 3,
                img: etcSvg,
                url: 'pages/service-common/index.html?file=service_etc.json&serviceId=etc&title=ETC服务',
                miniId: 'gh_7f57f7d2417e',
                data: '19;76;1'
            },{
                menuName: '便民医疗',
                menuType: 3,
                img: hospitalSvg,
                url: 'pages/service-common/index.html?file=service_bmyl.json&serviceId=bmyl&title=便民医疗',
                miniId: 'gh_7f57f7d2417e',
                data: '19;77;1'
            },{
                menuName: '住建不动产',
                menuType: 3,
                img: buildSvg,
                url: 'pages/service-common/index.html?file=service_zjbdc.json&serviceId=zjbdc&title=住建不动产',
                miniId: 'gh_7f57f7d2417e',
                data: '19;78;1'
            },{
                menuName: '养老退休',
                menuType: 3,
                img: oldSvg,
                url: 'pages/service-common/index.html?file=service_yltx.json&serviceId=yltx&title=养老退休',
                miniId: 'gh_7f57f7d2417e',
                data: '19;79;1'
            }, {
                menuName: '新生儿',
                menuType: 3,
                img: bornSvg,
                url: 'pages/service-common/index.html?file=service_xse.json&serviceId=xse&title=新生儿',
                miniId: 'gh_7f57f7d2417e',
                data: '19;80;1'
            }, {
                menuName: '医卫服务',
                menuType: 3,
                img: hospital2Svg,
                url: 'pages/service-common/index?file=service_medicalHealth.json&serviceId=medicalHealth&title=医卫服务',
                miniId: 'gh_7f57f7d2417e',
                data: '19;81;1'
            }, {
                menuName: '社会救助',
                menuType: 3,
                img: helpSvg,
                url: 'pages/service-common/index?file=service_shehuijz.json&serviceId=shehuijz&title=社会救助',
                miniId: 'gh_7f57f7d2417e',
                data: '19;82;1'
            }, {
                menuName: '助残',
                menuType: 3,
                img: sick2Svg,
                url: 'pages/service-common/index.html?file=service_zc2020.json&serviceId=zc2020&title=助残',
                miniId: 'gh_7f57f7d2417e',
                data: '19;83;1'
            }, {
                menuName: '投诉举报',
                menuType: 1,
                img: complainSvg,
                subMenu: [
                    {menuName: '我要投诉',desc: '投诉入口',url: 'pages/business/common/chooseCompany?businessType=complaint', miniId: 'gh_de0ebe7b5d4f',data: '21;87;1'},
                    {menuName: '我要举报',desc: '举报入口',url: 'pages/business/common/notice?type=report', miniId: 'gh_de0ebe7b5d4f',data: '21;87;1'},
                ]
            }]
        }
    },
    methods: {
        closeDialog() {
		    this.isShowDialog = false;
        },
		menuClick(item, index) {
            if(item.menuType == 1) {
                this.isShowDialog = true;
                this.dialogTitle = item.menuName
                this.dialogList = item.subMenu
                return;
            } else if(item.menuType == 2) {
                if(item.url == undefined) {
                    this[item.dialog] = true;
                } else {
                    if(item.url.indexOf('auth') != -1 && window.localStorage.getItem("token") != undefined) {
                        window.location.href = (item.url+ '&token=' + window.localStorage.getItem("token"));
                        return;
                    }
                    window.location.href = item.url
                }
            }
        }
    },
    mounted() {
        for(let index = 0; index < this.list.length; index++ ){
            let item = this.list[index]
            if(item.menuType != 3) {
                continue;
            }
            let btn = document.getElementById('launch-btn-c-'+ index);
            btn.addEventListener('launch',  (e) => {
                if(this.lock) {
                    return;
                }
                this.lock = true;
                let url = 'https://user.cs96111.com/ad/record/auth?data='+item.data;
                if(window.localStorage.getItem("token") != undefined) {
                    url += ('&token=' + window.localStorage.getItem("token"))
                }
                $.post(url, (result) => {
                    this.lock = false;
                });
            });
        }
    },
	components: {
        'DetailDialog': DetailDialog,
        'QrcodeDialog': QrcodeDialog
	}
}


// WEBPACK FOOTER //
// ./src/components/provincial_level/edu_service/js/edu_service.js